import { Grid } from '@mui/material';
import React, { useState } from 'react';
import PostToAccountFormView from '../../../components/account/create/post_to_ac/PostToAccountFormView';
import PostToAccountListView from '../../../components/account/create/post_to_ac/PostToAccountListView';
import { MahasulListDetailsProps } from '../../../helpers/models/Models';

const PostingMahasultoAccountCreatelistView = () => {
    const [onMahasulList, setOnMahasulList] = useState<MahasulListDetailsProps[] | null>(null);

  return (
    <Grid container spacing={2}>
        <Grid item xl={4} lg={4} md={4} sm={12} xs={12}>
            <PostToAccountFormView setOnMahasulList={setOnMahasulList} />
        </Grid>
        <Grid item xl={8} lg={8} md={8} sm={12} xs={12}>
            <PostToAccountListView onMahasulList={onMahasulList} />
        </Grid>
    </Grid>
  )
}

export default PostingMahasultoAccountCreatelistView